import { NOTIFICATIONS_PANEL_ID } from "PFApp/notifications/constants";
import { NotificationsPanel } from "PFApp/notifications/notifications_panel";
import { useAppLayoutStore } from "PFApp/stores/app_layout_store";

import css from "./left_action_panel.module.scss";

const LeftActionPanel = () => {
  const leftActionPanel = useAppLayoutStore((state) => state.leftActionPanel);

  return (
    <div className={leftActionPanel.collapsed ? css.collapsed : undefined} id="left_action_panel">
      <div className={css.spacer}>{/* spacer is so we can simply use this in a display: flex wrap */}</div>
      <div className={css.root}>
        {leftActionPanel.id === NOTIFICATIONS_PANEL_ID && <NotificationsPanel />}
      </div>
    </div>
  );
};

export default LeftActionPanel;
